import { Component, EventEmitter, Input, Output } from '@angular/core';

export type TabVariant = 'underline' | 'pill' | 'dark-pill';

@Component({
  selector: 'app-tab-bar',
  template: `
    <div class="tab-bar" [ngClass]="'tab-bar--' + variant" role="tablist">
      <button *ngFor="let tab of tabs; let i = index"
        class="tab-bar__tab"
        [class.tab-bar__tab--active]="i === activeIndex"
        role="tab"
        [attr.aria-selected]="i === activeIndex"
        (click)="select(i)">
        {{ tab }}
      </button>
    </div>
  `
})
export class TabBarNewComponent {
  @Input() tabs: string[] = [];
  @Input() activeIndex = 0;
  @Input() variant: TabVariant = 'underline';
  @Output() tabChange = new EventEmitter<number>();

  select(index: number): void {
    this.activeIndex = index;
    this.tabChange.emit(index);
  }
}
